import React from 'react'

// Drag-handle glyph (6 dots, 2x3) - same Material-Symbols-style viewBox
// convention as the other icons in this folder (IconDelete.jsx etc:
// "0 -960 960 960", fill/style passthrough via props). Used as the
// grabbable affordance on block cards for the container drag-and-drop
// feature - inherits currentColor rather than a fixed color, since it
// should just match whatever text color surrounds it (the type-label),
// not stand out as its own accent.
const IconGrip = ({ fillColor, style, ...props }) => {
  return (
   <svg {...props} xmlns="http://www.w3.org/2000/svg" className={'icon ' + fillColor} style={style} fill='currentColor' viewBox="0 -960 960 960">
      <circle cx="360" cy="-680" r="60" />
      <circle cx="600" cy="-680" r="60" />
      <circle cx="360" cy="-480" r="60" />
      <circle cx="600" cy="-480" r="60" />
      <circle cx="360" cy="-280" r="60" />
      <circle cx="600" cy="-280" r="60" />
   </svg>
  )
}
export default IconGrip
